import * as React from 'react';
import { connect } from 'react-redux';
import { updateBreadCrumbs } from '../../../redux/Actions/BreadCrumbs/ActionCreators';

import { RenderType, TemplateForm } from 'enchoice-fabric-react-lib';
import { IBreadcrumbItem } from 'office-ui-fabric-react/lib/Breadcrumb';
import { withRouter } from 'react-router';
import { Dispatch } from 'redux';

import { withTranslation } from 'react-i18next';

import './SearchTemplate.css';

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    updateBreadCrumbs: (items: IBreadcrumbItem[]) => dispatch(updateBreadCrumbs(items))
  };
};

const URL_BASE = '/templates/';

class SearchTemplate extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);

    const {
      match: { params }
    } = this.props;

    this.state = {
      templateId: params.templateId,
      hideDialog: false
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  public componentDidMount() {
    const items: IBreadcrumbItem[] = [
      { text: 'Home', key: '/home' },
      { text: 'Search By Template', key: `/search/template/${this.state.templateId}`, isCurrentItem: true }
    ];
    this.props.updateBreadCrumbs(items);
  }

  public render(): JSX.Element {
    const { t, location } = this.props;

    console.log(location);
    const isModal = !!(location.state && location.state.modal);
    const renderType: RenderType = isModal ? RenderType.DIALOG : RenderType.COMMANDBAR;

    return (
      <TemplateForm
        user="admin"
        url={URL_BASE + this.state.templateId}
        onCancel={this.onCancel}
        onSubmit={this.onSubmit}
        renderType={renderType}
        hideExternalSurface={!isModal}
        labelCmdBarCancel={t('templateSearch.cancel')}
        labelCmdBarSearch={t('templateSearch.search')}
      />
    );
  }

  private closeDialog = (): void => {
    this.setState({ hideDialog: true });
  };

  private onCancel(): void {
    console.log('onCancel ...');
    this.props.history.goBack();
    this.closeDialog();
  }

  private onSubmit(formAsJsonEncoded: string): void {
    console.log('onSubmit ...', formAsJsonEncoded);
    this.props.history.push(`/search/template/${this.state.templateId}/results?properties=${formAsJsonEncoded}`);
    this.closeDialog();
  }
}

export default withRouter(connect(
  null,
  mapDispatchToProps
)(withTranslation()(SearchTemplate)) as any);
